import EmptyState from '@/components/empty-state';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { formatRelativeTime } from '@/lib/time';
import type { Capture } from '@/types/capture';

interface Props {
  captures: Capture[];
  embedded?: boolean;
}

export default function CapturesCard({ captures, embedded = false }: Props) {
  const body =
    captures.length === 0 ? (
      <EmptyState description="No attached captures." className="py-2" />
    ) : (
      <ul className="divide-y">
        {captures.map((capture) => (
          <li key={capture.id} className="py-3">
            <p className="text-sm whitespace-pre-wrap">{capture.excerpt}</p>
            <div className="text-muted-foreground mt-2 flex flex-wrap gap-x-3 gap-y-1 text-xs">
              <span>{formatRelativeTime(capture.createdAt)}</span>
              {capture.openBrainUrl ? (
                <a
                  href={capture.openBrainUrl}
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-foreground underline"
                >
                  Open Brain
                </a>
              ) : (
                <span>{capture.openBrainId}</span>
              )}
            </div>
          </li>
        ))}
      </ul>
    );

  if (embedded) {
    return body;
  }

  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="text-base font-medium">Captures</CardTitle>
        <CardDescription>Open Brain pointers attached to this project.</CardDescription>
      </CardHeader>
      <CardContent>{body}</CardContent>
    </Card>
  );
}
